import React from "react";
import styled, { css } from "styled-components";

import { device } from "@scss/constants/mediaQuery";
import { StatsFilters, WeekSlider } from "@components/moleculs";

import type { FC } from "react";
import type { DateRange, Filters } from "@interfaces/stats";

type StatsProps = {
  filters: Partial<Filters>;
  dateRange: DateRange;
  onTimePercent: string;
};

const Stats: FC<StatsProps> = ({ filters, dateRange, onTimePercent }) => {
  return (
    <Wrapper>
      <WeekSlider range={dateRange} />
      <StatsFilters filters={filters} onTimePercent={onTimePercent} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 65%;

  display: flex;
  flex-direction: column;

  ${device.laptopS(css`
    height: 100%;
    width: 60%;
  `)}

  ${device.laptopL(css`
    width: 50%;
  `)}
`;

export default Stats;
